import React, { Component } from 'react';
import { connect } from 'react-redux';
import { switchMainTabDispatch, unsetCommitteeTab } from '../actions';

class MainTab extends Component {

	constructor( props ) {
		super( props );
		this.state = {
			active_tab: 'My Dashboard'
		};
	}

	switchTab( tabName ) {
		this.props.switchMainTabDispatch( tabName );
		this.updateState( tabName );
	}

	updateState( tabName ) {
		var newState = this.state;
		newState.active_tab = tabName;
		this.setState( newState );
	}

	getTabs() {
		if ( typeof this.props.tabs !== 'undefined' ) {
			return this.props.tabs.map( ( tab, index ) => {
				var elementClass = (index === this.props.tabs.length - 1
				                   )
					? 'committee-main-tab last-tab'
					: 'committee-main-tab';
				elementClass += (tab.name !== this.state.active_tab
				                ) ? ' non-active-main-tab' : '';
				var glyphicon = (tab.icon !== ''
				                ) ? (
					                <span className={ tab.icon } aria-hidden="true" />
				                ) : '';
				return (
					<div className={ elementClass } data-tab={ tab.name } onClick={ this.switchTab.bind( this, tab.name ) }>
						{ glyphicon }
						{ tab.name }
					</div>
				);
			} );
		}
	}

	render() {
		if ( this.props.mainTab !== this.state.active_tab ) {
			this.updateState( this.props.mainTab );
		}

		return (
			<div className="container">
				<div className="main-tab-container">
					{ this.getTabs() }
				</div>
				<div className="tab-indicator-container">
					{this.props.tabs.map((tab, index) => (
						<div key={index} className={"tab-indicator " + (tab.name === this.state.active_tab ? 'active-tab-indicator' : '')} onClick={ this.switchTab.bind( this, tab.name ) }></div>
					))}
				</div>
			</div>
		);
	}

}

function mapStateToProps( { currentTabs, myCommittees, requestedCommittees, myCommitteeTab, mainTab } ) {
	return {
		currentTabs, myCommittees, requestedCommittees, myCommitteeTab, mainTab
	};
}

export default connect( mapStateToProps, {
	switchMainTabDispatch,
	unsetCommitteeTab
} )( MainTab );